import * as THREE from "three"
import { environment, garments, loaders, scene } from "./Experience"

import patchVertexShader from "../../shaders/patch/vertex.glsl"
import patchFragmentShader from "../../shaders/patch/fragment.glsl"

import patchParticlesVertexShader from "../../shaders/patch/particles/vertex.glsl"
import patchParticlesFragmentShader from "../../shaders/patch/particles/fragment.glsl"

import patchSwirlsVertexShader from "../../shaders/patch/swirls/vertex.glsl"
import patchSwirlsFragmentShader from "../../shaders/patch/swirls/fragment.glsl"

import patchConnectorVertexShader from "../../shaders/patch/connector/vertex.glsl"
import patchConnectorFragmentShader from "../../shaders/patch/connector/fragment.glsl"

export class Patch {
  constructor() {}

  setPatch() {}

  setPatchBackground() {
    garments.patchBackground.material = new THREE.ShaderMaterial({
      vertexShader: patchVertexShader,
      fragmentShader: patchFragmentShader,

      uniforms: {
        uTime: { value: 0 },
        uColor1: { value: new THREE.Color("#30366e") },
        uColor1: { value: new THREE.Color("#15192f") },
      },
      stencilWrite: true,
      stencilFunc: THREE.EqualStencilFunc,
      stencilRef: 2,
      // stencilZPass: THREE.ReplaceStencilOp
    })
  }

  setPatchParticles() {
    const particleCount = 2000

    const geometry = new THREE.BufferGeometry()

    const positions = []
    const positionVectors = []
    const randoms = new Float32Array(particleCount)
    const colors = []

    const color = new THREE.Color()

    const n = 0.08,
      n2 = n / 2 // particles spread in the sphere + put sphere in center

    for (let i = 0; i < particleCount; i++) {
      // positions
      const x = Math.random() * n - n2
      const y = Math.random() * n - n2
      const z = Math.random() * n - n2

      positionVectors.push(new THREE.Vector3(x, y, z))

      if (positionVectors[i].distanceTo(new THREE.Vector3(0, 0, 0)) < n / 2) {
        positions.push(x, y, z)
        randoms[i] = Math.random()
      }
    }

    geometry.setAttribute(
      "position",
      new THREE.Float32BufferAttribute(positions, 3)
    )
    geometry.setAttribute("aRandom", new THREE.BufferAttribute(randoms, 1))

    geometry.computeBoundingSphere()

    this.patchParticlesMaterial = new THREE.ShaderMaterial({
      vertexShader: patchParticlesVertexShader,
      fragmentShader: patchParticlesFragmentShader,
      transparent: true,
      blending: THREE.AdditiveBlending,
      depthWrite: false,

      uniforms: {
        uTime: { value: 0 },
        uPixelRatio: { value: Math.min(window.devicePixelRatio, 2) },
        uColor1: {
          value: new THREE.Color("#68ddf5"),
        },
        uColor2: {
          value: new THREE.Color("#3560bd"),
        },
      },
    })

    this.patchParticlesPoints = new THREE.Points(
      geometry,
      this.patchParticlesMaterial
    )

    this.patchParticlesPoints.position.copy(garments.patchParticles.position)

    this.patchParticlesPoints.material.stencilWrite = true
    this.patchParticlesPoints.renderOrder = 4
    this.patchParticlesPoints.material.stencilRef = 2
    this.patchParticlesPoints.material.stencilFunc = THREE.EqualStencilFunc

    scene.add(this.patchParticlesPoints)
  }

  setSwirls() {}

  setConnector() {
    // garments.patchConnectorMesh.visible = false
    //
    // this.patchConnectorMaterial = new THREE.ShaderMaterial({
    //   vertexShader: patchConnectorVertexShader,
    //   fragmentShader: patchConnectorFragmentShader,
    //   transparent: true,
    //   blending: THREE.AdditiveBlending,
    //   depthWrite: false,
    //
    //   uniforms: {
    //     uTime: { value: 0 },
    //     uPixelRatio: { value: Math.min(window.devicePixelRatio, 2) },
    //   },
    // })
    //
    // this.patchConnector = new THREE.Points(
    //   garments.patchConnectorMesh.geometry,
    //   this.patchConnectorMaterial
    // )
    // scene.add(this.patchConnector)
  }

  update(elapsedTime) {
    // garments.patchBackground.material.uniforms.uTime.value = elapsedTime
    this.patchParticlesPoints.material.uniforms.uTime.value = elapsedTime
    // this.patchConnectorMaterial.uniforms.uTime.value = elapsedTime
  }
}
